import { updateHomeText } from './updateHomeTextThunk';
export default updateHomeText;
